import { type AxiosRequestConfig, type AxiosResponse } from "axios";

import { type ChartIndex } from "shared/modules/Charts/types";
import { type ChartLibraryRequestParams } from "shared/modules/Charts/types/data";
import { type InstantInsightsReport } from "shared/resources";
import { type InsightsResponse } from "shared/services/api/StreamService";
import { type Nullable } from "shared/types";

import InsightsService from "./InsightsService";
import PublicInsightsService from "./PublicInsightsService";

export interface InsightsServiceInterface {
  chartsConfig(): Promise<ChartIndex>;
  dashboard(
    id?: number,
    options?: { signal?: AbortSignal }
  ): Promise<Nullable<InstantInsightsReport>>;
  streamInsights(
    streamId: string | number,
    options?: AxiosRequestConfig<ChartLibraryRequestParams>
  ): Promise<AxiosResponse<InsightsResponse>>;
}

function createInsightsService({
  publicAccessKey,
}: { publicAccessKey?: string } = {}): InsightsServiceInterface {
  if (publicAccessKey) {
    return new PublicInsightsService(publicAccessKey);
  }

  return new InsightsService();
}

export default createInsightsService;
